export default __webpack_public_path__ + "e9922e488eeb08b8bf88bb31091ee43b.png";